import React from 'react';
import TridentIcon from '../TridentIcon';
import { Reveal } from '../Reveal';
import { EditionToggle } from './EditionToggle';
import { ShareConfig } from './ShareConfig';

const Heading = ({ children }) => (
  <h3 className="adetails-h">{children}<span className="adetails-rule" aria-hidden><i /><b>✦</b><i /></span></h3>
);

const Swatches = ({ options, value, onChange, kind }) => (
  <div className="aswatches" role="radiogroup" aria-label={`${kind} options`}>
    {options.map((o) => (
      <button
        key={o.id}
        type="button"
        role="radio"
        aria-checked={value === o.id}
        className={`aswatch aswatch--${o.id} ${value === o.id ? 'is-active' : ''}`}
        onClick={() => onChange(o.id)}
        data-testid={`${kind}-option-${o.id}`}
      >
        <span className="aswatch-disc" aria-hidden />
        <span>{o.name}</span>
      </button>
    ))}
  </div>
);

export const ArtifactDetails = ({ realm, piece, config }) => {
  const { metal, stone, isEx, setMetal, setStone } = config;
  const edition = isEx ? 'ex' : 'original';
  const showMetals = isEx || realm.metalsInOriginal;
  return (
    <Reveal>
      <section className="adetails" data-testid="artifact-details">
        <div>
          <Heading>Details</Heading>
          <dl className="aspec">
            <dt>Metal</dt><dd data-testid="detail-metal">{realm.metalDetail[edition]}</dd>
            <dt>Stone</dt><dd data-testid="detail-stone">{realm.stoneDetail[edition]}</dd>
            <dt>Dimensions</dt><dd data-testid="detail-dimensions">{piece.dimensions}</dd>
          </dl>
        </div>

        <div className="aoptions">
          <Heading>Edition</Heading>
          <EditionToggle realm={realm} config={config} id="edition" />
          <Heading>Material Options</Heading>
          {showMetals ? (
            <Swatches options={realm.metals} value={metal} onChange={setMetal} kind="metal" />
          ) : (
            <p className="ametal-tba" data-testid="metal-tba">Metal — to be announced</p>
          )}
          <Heading>Stone Options</Heading>
          <Swatches options={realm.stones} value={stone} onChange={setStone} kind="stone" />
          <div className="ashare-row">
            <ShareConfig realm={realm} piece={piece} config={config} variant="text" />
          </div>
        </div>

        <div className="aclosing" data-testid="artifact-closing">
          <TridentIcon className="w-6 h-6" color="#C8A45D" />
          <p className="aclosing-text">
            {piece.closing.map((line, i) => (
              <React.Fragment key={line}>{i > 0 && <br />}{line}</React.Fragment>
            ))}
          </p>
        </div>
      </section>
    </Reveal>
  );
};
